"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _Fade = _interopRequireDefault(require("../Fade"));
var _createStyles = require("../styles/createStyles");
const _excluded = ["children", "classes", "className", "invisible", "open", "transitionDuration"];
const useStyles = exports.useStyles = (0, _createStyles.createStyles)(_ref => {
  let {
    theme
  } = _ref;
  return {
    /* Styles applied to the root element. */
    root: {
      // Improve scrollable dialog support.
      zIndex: -1,
      position: 'fixed',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      right: 0,
      bottom: 0,
      top: 0,
      left: 0,
      backgroundColor: theme.busbud.colors.component.backdrop,
      WebkitTapHighlightColor: 'transparent'
    },
    /* Styles applied to the root element if `invisible={true}`. */
    invisible: {
      backgroundColor: 'transparent'
    }
  };
});
/**
 *
 * The backdrop component is used to provide emphasis on a particular element or parts of it.
 *
 * The backdrop signals to the user of a state change within the application and can be used for creating loaders, dialogs and more. In its simplest form, the backdrop component will add a dimmed layer over your application.
 *
 * [Storybook](https://busbud.github.io/design-system/?path=/docs/components-feedback-backdrop--page)
 */
const Backdrop = /*#__PURE__*/_react.default.forwardRef(function Backdrop(props, ref) {
  const {
      children,
      classes: classesOverrides,
      className,
      invisible = false,
      open,
      transitionDuration
    } = props,
    other = (0, _objectWithoutProperties2.default)(props, _excluded);
  const {
    classes,
    cx
  } = useStyles({
    classesOverrides
  });
  return /*#__PURE__*/_react.default.createElement(_Fade.default, (0, _extends2.default)({
    in: open,
    timeout: transitionDuration
  }, other), /*#__PURE__*/_react.default.createElement("div", {
    "data-testid": "Backdrop",
    className: cx(classes.root, {
      [classes.invisible]: invisible
    }, className),
    "aria-hidden": true,
    ref: ref
  }, children));
});
var _default = exports.default = Backdrop;